// ** Core JWT Import
// useJwt here is a factory (not a React Hook); it returns a JwtService instance.
import useJwt from '@src/@core/auth/jwt/useJwt'

// eslint-disable-next-line react-hooks/rules-of-hooks
const { jwt } = useJwt({})

export default jwt
